import {FC} from 'react';
import {
	isFinanceSelfEmploymentFlow,
	MY_TAX_CHECKING_TITLE,
	MyTaxCheckingMode,
	getMyTaxCheckingDescription,
	RegistrationWorkStatus,
} from '../../model';
import {HourglassIllustrationIcon, MyTaxAccessIllustrationIcon} from 'shared/assets/icons';
import {StepLayout} from 'features/registration';
import styles from './MyTaxCheckingStep.module.css';

type Props = {
	mode: MyTaxCheckingMode;
	workStatus?: RegistrationWorkStatus | null;
};

export const MyTaxCheckingStep: FC<Props> = ({mode, workStatus = null}) => {
	const Illustration = isFinanceSelfEmploymentFlow(workStatus)
		? HourglassIllustrationIcon
		: MyTaxAccessIllustrationIcon;

	return (
		<StepLayout variant="fill" className={styles.root}>
			<StepLayout.Content className={styles.centered}>
				<Illustration className={styles.icon} aria-hidden />

				<div className={styles.text}>
					<StepLayout.Title>{MY_TAX_CHECKING_TITLE}</StepLayout.Title>
					<StepLayout.Subtitle muted>{getMyTaxCheckingDescription(mode)}</StepLayout.Subtitle>
				</div>
			</StepLayout.Content>
		</StepLayout>
	);
};
